<template>
  <svg width="15" height="14" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_11034_6842)">
      <path d="M6.22928 10.5868L12.0165 7.25363C12.1073 7.20153 12.1632 7.10465 12.1632 7.00031C12.1632 6.89597 12.1073 6.79909 12.0165 6.74685L6.22928 3.41321C6.13847 3.36096 6.02668 3.36096 5.93586 3.41321C5.84505 3.46545 5.78915 3.56218 5.78915 3.66667V5.21861H0.793418C0.631451 5.21861 0.5 5.34973 0.5 5.5113V8.48845C0.5 8.65001 0.631451 8.78114 0.793418 8.78114H5.7893V10.3329C5.7893 10.4377 5.8452 10.5342 5.93601 10.5864C5.98149 10.6127 6.0321 10.6256 6.08272 10.6256C6.13333 10.6256 6.18395 10.6127 6.22928 10.5868Z" fill="currentColor"/>
      <path d="M12.3322 0H6.35396C6.192 0 6.06055 0.131122 6.06055 0.292682V1.17073C6.06055 1.33229 6.192 1.46341 6.35396 1.46341H12.3322C12.7183 1.46341 13.0322 1.77673 13.0322 2.1616V11.8384C13.0322 12.2234 12.7181 12.5366 12.3322 12.5366H6.35396C6.192 12.5366 6.06055 12.6677 6.06055 12.8293V13.7073C6.06055 13.8689 6.192 14 6.35396 14H12.3322C13.5273 14 14.4992 13.0302 14.4992 11.8384V2.16175C14.4992 0.969801 13.5272 0 12.3322 0Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_11034_6842">
        <rect width="14" height="14" fill="currentColor" transform="translate(0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
name: "IconLogout2"
}
</script>

<style scoped>

</style>